export default __webpack_public_path__ + "static/media/resources.bda8f6f6.mp3";